import { axiosPrivate } from 'app/utils';
import helpers from '../helpers';

export default {
  async getPharmacyPhotoOrders({ pharmacyId, userId }) {
    if (!pharmacyId || !userId) {
      return [];
    }
    const response = await axiosPrivate.get(
      `/v3/pharmacist/pharmacies/${pharmacyId}/photo-orders?userId=${userId}`,
      {}
    );
    if (response.data.error) helpers.throwError(response.data.error);
    return {
      requests:
        response.data?.photoOrders?.map((request) => ({
          id: request.id,
          images: request.files,
          notes: request.notes,
        })) || [],
      pagination: {
        ...response.data?.pagination,
        current_page: response.data?.pagination?.currentPage,
      },
    };
  },
};
